<template>
    <div class="data-list-container">
        <vs-table ref="table" max-items="10" :data="trainings">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <div
                            @click="loadTranings(page)"
                            class="btn-add-new p-3 mb-4 mt-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Actualiser</span>
                    </div>
                    <div v-if="isAdmin()"
                         @click="$router.push({name: 'formation-add'})"
                         class="btn-add-new p-3 mb-4 mt-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                        <span class="ml-2 text-base text-primary">Ajouter une formation</span>
                    </div>

                    <!--<span style="margin-left: -10px">Filtrer par type</span>-->
                    <vs-row>
                        <vs-col vs-w="6">
                            <v-select v-model="params.type" class="w-full ml-1"  label="name"
                                      placeholder="Filtrer par type"
                                      :reduce="type => type.slug"
                                      :options="types"></v-select>
                        </vs-col>
                        <vs-col vs-w="6">
                            <v-select v-model="params.category" class="w-full ml-2" vs-w="6" label="name"
                                      placeholder="Filtrer par catégorie"
                                      :reduce="category => category.slug"
                                      :options="categories"></v-select>
                        </vs-col>
                    </vs-row>
                </div>
                <div class="con-input-search vs-table--search">
                    <input v-model="search" @keypress.enter="searchInfo()" type="text" class="input-search vs-table--search-input">
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="title">Titre</vs-th>
                <vs-th sort-key="category_training_id">Catégorie</vs-th>
                <vs-th sort-key="user_id">Auteur</vs-th>
                <vs-th>Publiée ?</vs-th>
                <vs-th>Fermée ?</vs-th>
                <vs-th sort-key="teams">Equipes</vs-th>
                <vs-th sort-key="date_start">Date de début</vs-th>
                <vs-th sort-key="date_end">Date de fin</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.title.substring(0, 30) + '...' }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.category ? tr.category : '---' }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.author ? tr.author : "---"}}</p>
                    </vs-td>

                    <vs-td>
                        <vs-chip
                                :color="tr.published == '1' ? 'success' : 'danger'"
                        >{{ tr.published ? 'Oui' : 'Non'}}
                        </vs-chip>
                    </vs-td>

                    <vs-td>
                        <vs-chip :color="tr.closed == '1' ? 'success' : 'danger'">{{ tr.closed ? 'Oui' : 'Non'}}</vs-chip>
                    </vs-td>

                    <vs-td>
                        <p class="product-price">{{ tr.teams }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-price">{{ tr.date_start ? tr.date_start : '---' }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="product-price">{{ tr.date_end ? tr.date_end : '---' }}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <div class="flex">
                            <vx-tooltip text="Détails de la formation">
                                <feather-icon @click="$router.push({name: 'formation-show', params:{slug: tr.slug}})"
                                              icon="EyeIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Fréquentation par agent" v-if="isAdmin()">
                                <feather-icon @click="$router.push({name: 'formation-tracking', params:{id: tr.id}})"
                                              icon="BarChartIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>

                            <vx-tooltip text="Modifier la formation" v-if="isAdmin()">
                                <feather-icon @click="$router.push({name: 'formation-edit', params:{slug: tr.slug}})"
                                              icon="EditIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Supprimer la formation" v-if="isAdmin()">
                                <feather-icon @click="deleteData(tr.slug)"
                                              icon="XIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>

                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        &nbsp;&nbsp;&nbsp;
        <vs-row>
            <vs-col vs-offset="5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
            </vs-col>
        </vs-row>


        <vs-prompt
                color="red"
                title="Suppression"
                @cancle="deletePopupItem = false"
                @accept="deleteData()"
                accept-text="OUI"
                @close="deletePopupItem = false"
                :active.sync="deletePopupItem"
        >
            <div class="flex">
                <span>Etes-vous sûr de faire la suppression ?</span>
            </div>
        </vs-prompt>
    </div>
</template>

<script>

    import axios from "axios";
    import {_buildQuery} from "../../../helpers/buildquery";
    import Datepicker from "vuejs-datepicker";
    import moment from "moment";
    import vSelect from "vue-select";

    export default {
        components: {
            Datepicker, vSelect
        },
        data() {
            return {
                type: {name: "Sélectionner une option", slug: ""},
                param: new FormData(),
                deletePopupItem: false,
                loading: false,
                trainings: [],
                itemsPerPage: 4,
                isMounted: false,
                published: false,
                params: {
                    page: 1,
                    type: "",
                    category: "",
                    limit: 18
                },
                search: '',
                medias: [],
                types: [],
                url: "/trainings",
                formErrors: {},
                type_agencies: [],
                categories: [],
                page: 1,
                last_page: null,
            };
        },
        watch: {
            "params.type": function () {
                this.loadTranings(this.page);
            },
            "params.category": function () {
                this.loadTranings(this.page);
            },

            page(value) {
                this.loadTranings(value);
            },

        },
        computed: {
            parseDate(date) {
                return moment(date).format('YYYY-MM-DD')
            },
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            }

        },
        methods: {
            isAdmin() {
                return this.$store.state.AppActiveUser.roles[0].name === 'admin' ? true : false;
            },
            isAgent() {
                // console.log('this.$store.state.AppActiveUser.roles[0].name: ', this.$store.state.AppActiveUser.roles[0].name)
                return this.$store.state.AppActiveUser.roles[0].name === 'agent' ? true : false;
            },
            isTeamChef() {
                return this.$store.state.AppActiveUser.roles[0].name === 'chef equipe' ? true : false;
            },
            isRegionalSupervisor(){
                return this.$store.state.AppActiveUser.roles[0].name === 'superviseur regional' ? true : false;
            },
            showDeleteModal(slug) {
                this.training_select_slug = slug;
                this.deletePopupItem = true;
            },
            deleteData(slug) {
                if (confirm("Voulez-vous vraiment supprimer cette formation ?")) {
                    this.loading = true;
                    this.$vs.loading();
                    //alert(this.training_select_slug)
                    axios
                        .delete("trainings/" + slug, {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("accessToken")
                            }
                        })
                        .then(response => {
                            this.loading = false;
                            this.$vs.loading.close();
                            if (response.status === 200) {
                                window.getApp.success("La formation  a été supprimée avec succès.");
                                //this.hideDeleteModal();
                                this.loadTranings();
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.$vs.loading.close();
                            console.log("error " + JSON.stringify(error));
                        });
                }
            },
            searchInfo(){
                if (this.search != ''){
                    this.$vs.loading();
                    this.$http.get('trainings' + _buildQuery({search: this.search})).then((response) => {
                        this.$vs.loading.close();
                        this.trainings = response.data;
                        this.search = ''
                        this.last_page = null
                    }).catch(error => {
                        this.$vs.loading.close();
                        console.log("error " + JSON.stringify(error));
                    });
                }
            },
            loadTranings(page) {
                if (this.checkIfuserHasRole("agent")) {
                    this.$router.push({path: "/formation/all/agent"});
                } else {

                    this.params.page = page;
                    this.params.type = this.params.type ? this.params.type : ''
                    this.params.category = this.params.category ? this.params.category : ''

                    this.loading = true;
                    this.$vs.loading();
                    axios
                        .get("trainings" + _buildQuery(this.params), {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("accessToken")
                            }
                        })
                        .then(response => {
                            this.loading = false;
                            this.$vs.loading.close();
                            this.trainings = response.data.data;
                            this.last_page = response.data.last_page;
                        })
                        .catch(error => {
                            this.loading = false;
                            this.$vs.loading.close();
                            console.log("error " + JSON.stringify(error));
                        });
                }
            },
            getTypes() {
                this.types = []
                this.$http.get("/types/trainings").then(response => {
                    this.types = response.data.data

                });
            },
            getCategories() {
                this.categories = []
                this.$http.get("/categories/trainings").then(response => {
                    this.categories = response.data
                });
            },
            resetErrors(field) {
                if (field) {
                    this.formErrors[field] = null;
                } else {
                    this.formErrors = [];
                    Object.keys(this.input).forEach(index => (this.input[index] = null));
                }
            }
        },
        created() {
            this.loadTranings(this.page);
            this.getTypes();
            this.getCategories();
        },
        mounted() {
            this.isMounted = true;
        }
    };
</script>

<style lang="scss">
    @import "vue-select/src/scss/vue-select.scss";

</style>

